var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "c-table",
            {
              ref: "table",
              attrs: {
                title: "체크리스트 목록",
                isTitle: true,
                columns: _vm.grid.columns,
                gridHeight: _vm.gridHeight,
                data: _vm.tabParam.ctoChecklistModels,
                editable: _vm.editable && !_vm.disabled,
                gridHeightAuto: true,
                filtering: false,
                isExcelDown: false,
                columnSetting: false,
                usePaging: false,
                noDataLabel: "체크리스트를 추가하세요.",
                selection: "multiple",
                rowKey: "sopCtoChecklistId",
              },
              on: { changeSelection: _vm.changeSelection },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props }) {
                    return [
                      [
                        _c("q-btn", {
                          attrs: {
                            flat: "",
                            size: "12px",
                            color: "orange",
                            icon: "chevron_right",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.rowClickDetail(
                                props.row,
                                props.pageIndex
                              )
                            },
                          },
                        }),
                      ],
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [_c("q-btn-group", { attrs: { outline: "" } })],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          attrs: { position: _vm.positionDetail },
          model: {
            value: _vm.dialogDetail,
            callback: function ($$v) {
              _vm.dialogDetail = $$v
            },
            expression: "dialogDetail",
          },
        },
        [
          _c(
            "q-card",
            { staticStyle: { width: "100%" } },
            [
              _c("q-linear-progress", { attrs: { value: 1, color: "pink" } }),
              _c("q-card-section", { staticClass: "row" }, [
                _c("div", {
                  staticClass: "col-12 text-weight-bold-dailog",
                  domProps: {
                    textContent: _vm._s(_vm.selectedRow.patrolItemName),
                  },
                }),
                _c("div", { staticClass: "col-4" }, [
                  _c("div", { staticClass: "mini-dailog-title" }, [
                    _vm._v("개선진행 상태"),
                  ]),
                ]),
                _c("div", { staticClass: "col-8 mini-dailog-btn-impr" }, [
                  _vm.editable &&
                  Boolean(_vm.selectedRow.sopCtoChecklistId) &&
                  _vm.selectedRow.editFlag !== "C" &&
                  !_vm.disabled
                    ? _c(
                        "div",
                        [
                          _c(
                            "q-btn-group",
                            { attrs: { outline: "" } },
                            [
                              _vm.editable && !_vm.disabled
                                ? _c("c-btn", {
                                    attrs: {
                                      showLoading: false,
                                      label: "개선요청",
                                      color: "red-6",
                                      "text-color": "white",
                                    },
                                    on: {
                                      btnClicked: function ($event) {
                                        return _vm.innerBtnClicked(
                                          _vm.selectedRow,
                                          "1"
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm.editable && !_vm.disabled
                                ? _c("c-btn", {
                                    attrs: {
                                      showLoading: false,
                                      label: "즉시조치",
                                      color: "light-blue",
                                      "text-color": "white",
                                    },
                                    on: {
                                      btnClicked: function ($event) {
                                        return _vm.innerBtnClicked(
                                          _vm.selectedRow,
                                          "2"
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _c(
                  "div",
                  { staticClass: "col-12 border-impr-dialog" },
                  [
                    _vm.selectedRow["sopImprovementIds"] &&
                    _vm.selectedRow["ibmStepNames"]
                      ? _vm._l(
                          _vm.$comm.ibmTagItems(
                            _vm.selectedRow,
                            _vm.colorItems
                          ),
                          function (item, index) {
                            return _c(
                              "q-chip",
                              {
                                key: index,
                                staticStyle: {
                                  "margin-bottom": "4px !important",
                                },
                                attrs: {
                                  color:
                                    item.ibmClassCd === "IC00000001"
                                      ? "blue-6"
                                      : "orange",
                                  clickable: true,
                                  "text-color": "white",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.linkClick(item, _vm.selectedRow)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(item.title) + " ")]
                            )
                          }
                        )
                      : [_vm._v(" 등록된 개선요청 및 즉시조치가 없습니다. ")],
                  ],
                  2
                ),
                _c("div", { staticClass: "col-12" }, [_vm._v("  ")]),
                _c(
                  "div",
                  { staticClass: "col-12 mini-dailog-btn-impr" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _c("c-btn", {
                          attrs: {
                            showLoading: false,
                            label: "닫기",
                            icon: "close",
                          },
                          on: { btnClicked: _vm.dialogClose },
                        }),
                        _vm.editable && !_vm.disabled
                          ? _c("c-btn", {
                              attrs: {
                                showLoading: false,
                                label: "적용",
                                icon: "check",
                                color: "amber-7",
                              },
                              on: { btnClicked: _vm.dialogSubmit },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "popup-bottom-bar" }, [
        _c(
          "div",
          { staticClass: "popup-bottom-bar-btngroup" },
          [
            _c(
              "q-btn-group",
              { attrs: { outline: "" } },
              [
                _vm.editable && !_vm.disabled
                  ? _c("c-btn", {
                      attrs: { flat: true, label: "추가", icon: "add" },
                      on: { btnClicked: _vm.addChecklist },
                    })
                  : _vm._e(),
                _vm.editable &&
                !_vm.disabled &&
                _vm.tabParam.ctoChecklistModels.length > 0
                  ? _c("c-btn", {
                      attrs: { flat: true, label: "삭제", icon: "delete" },
                      on: { btnClicked: _vm.deleteChecklist },
                    })
                  : _vm._e(),
                _vm.editable &&
                !_vm.disabled &&
                _vm.tabParam.ctoChecklistModels.length > 0
                  ? _c("c-btn", {
                      attrs: {
                        flat: true,
                        url: _vm.saveUrl,
                        isSubmit: _vm.isSave,
                        param: _vm.tabParam.ctoChecklistModels,
                        mappingType: "POST",
                        label: "저장",
                        icon: "save",
                      },
                      on: {
                        beforeAction: _vm.saveChecklist,
                        btnCallback: _vm.saveCallback,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "popup-bottom-bar-close" },
          [
            _c("q-btn", {
              attrs: { flat: "", color: "gray", icon: "arrow_back" },
              on: { click: _vm.closePopUps },
            }),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }